<!--@format-->
<template>
    <div class="user-reauthenticated-popup">
        <section class="description">
            <p>Enter your password to authorize the payment.</p>
        </section>
        <section class="user-info-container">
            <div>
                <span>User: {{ user.email }}</span>
            </div>
            <app-input
                v-model="user.password"
                label="Password"
                type="password"
                :is-valid="!error"
                :error="error"
            />
        </section>
        <div v-if="!actions" class="app-popup-actions inner-actions">
            <app-button class="tertiary-btn" @click="closePopup"> Cancel </app-button>
            <app-button
                :disabled="!user.password"
                :loading="paymentInProcess"
                @click="handleAuthorize"
            >
                Authorize Payment
            </app-button>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button');
const AppInput = () => import('@/components/common/app-input');

import EventBus from '@/scripts/event-bus';
import AppPopup from '@/components/popups/app-popup';
import { MDFInvoicesService } from '@/scripts/services/invoices/mdf-invoices-service.js';

export default {
    name: 'user-reauthenticated-popup',

    components: {
        'app-button': AppButton,
        'app-input': AppInput,
    },

    props: {
        actions: {
            type: Object,
            default: null,
        },

        element: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            user: {
                email: '',
                password: '',
            },

            error: '',

            paymentInProcess: false,
        };
    },

    computed: {
        userEmail() {
            return this.$store.state.user.email;
        },
    },

    created() {
        this.user.email = this.userEmail;
    },

    methods: {
        makePayment(user) {
            this.paymentInProcess = true;
            const body = {
                Password: user.password,
                PaymentMethodId: this.element.paymentDetails.payMethod.id,
            };
            MDFInvoicesService.makePayment(
                body,
                this.element.paymentDetails.invoiceId,
                this.element.accountId,
            )
                .then(() => {
                    EventBus.$emit('payment:success-step');
                    EventBus.$emit('invoice-details-update');
                    EventBus.$emit('invoice:update');
                    this.$helpers.showSuccessNotification('Successful payment.');
                    this.closePopup();
                })
                .catch((error) => {
                    if (error.response.status === 401) {
                        this.error = 'The password you entered is invalid. Please try again.';
                    } else {
                        this.closePopup();
                        this.$modal.show(
                            AppPopup,
                            {
                                type: 'alert-popup',
                                title: 'Error Processing Payment',
                                content:
                                    '<p>Oh no! It looks like we ran into some trouble processing your payment. Please take a moment to double-check your payment details and give it another try. If you’re still having trouble, feel free to reach out to us and we’ll do our best to assist you.</p>',
                            },
                            {
                                height: this.$helpers.setPopupHeight(),
                                width: this.$helpers.setPopupWidth(),
                            },
                        );
                    }
                })
                .finally(() => {
                    this.paymentInProcess = false;
                    EventBus.$emit('payment:finished');
                });
        },

        handleAuthorize() {
            this.makePayment(this.user);
        },

        closePopup() {
            this.$emit('close');
        },
    },
};
</script>

<style>
.user-reauthenticated-popup {
    text-align: left;
}

.user-reauthenticated-popup .user-info-container {
    font-weight: 600;
}

.user-reauthenticated-popup label {
    color: #382153;
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    font-family: 'Roboto';
}

.user-reauthenticated-popup .app-popup-actions.inner-actions {
    border-top: 2px solid #e9e9ef;
    margin: 40px 0 0;
}

.user-reauthenticated-popup .add-message .app-textarea textarea::-webkit-scrollbar {
    width: 9px;
    height: 9px;
}

.user-reauthenticated-popup .add-message .app-textarea textarea::-webkit-scrollbar-track {
    border-radius: 32px;
}

.user-reauthenticated-popup .add-message .app-textarea textarea::-webkit-scrollbar-thumb {
    border-radius: 32px;
    background: rgb(193, 193, 197);
}
</style>
